import Header from "components/Primary/Header";
import EcosystemOverview from "components/Secondary/EcosystemOverview";
import MarketsPromoBar from "components/Secondary/MarketsPromoBar";

import { formatNumber } from "helpers/helpers";
import StatsSection from "components/Secondary/StatsSection";
import "./style.scss";
import MarketsList from "components/Secondary/MarketsList";
import MarketsTop from "components/Secondary/MarketsTop";

const MarketsPage = ({}) => {
  return <div className="marketsPage">
    <Header/>
    <div className="marketsMain">
      <div className="sidebar">
        <EcosystemOverview/>
      </div>
      <div className="mainWrapper">
        <div className="main">
          <MarketsPromoBar/>
          <StatsSection items={[{
            label: "Trading Volume",
            value: "$" + formatNumber(10495942.34,2),
            description: "in 24 hours"
          },
          {
            label: "Number of Trades",
            value: "$" + formatNumber(14023,2),
            description: "in 24 hours"
          }]}/>

          <MarketsTop title={"Markets"} filters={["All", "Featured", "DeFi", "Gaming", "Metaverse"]}/>
          
          <MarketsList/>
        </div>
      </div>
      
    </div>
  </div>
}

export default MarketsPage;